import { createSlice } from "@reduxjs/toolkit";

const fwList1 = [
  {
    "siteId": "2e7787ef-7f28-493e-8560-e9b69f771999",
    "siteName": "office",
    "siteTimezone": "+08:00",
    "siteTimezoneName": "Asia/Taipei",
    "deviceType": "ap", // ap, switch
    "seriesName": "DAP-X2810",
    "hwVersion": "A",  // Ax, Bx
    "devices": [
      {
        "id": "BC:22:28:72:0F:70",
        "name": "office ap 1",
        "modelName": "DAP-X2810",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
      {
        "id": "BC:22:28:72:0F:80",
        "name": "office ap 2",
        "modelName": "DAP-X2810",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
      {
        "id": "BC:22:28:72:0F:90",
        "name": "office ap 3",
        "modelName": "DAP-X2810",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
    ],
    "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
    "firmwareVersion": "1.0.0",
    "firmwareId": 1,
    "targetFirmwareVersion": "2.0",
    "targetFirmwareId": 2,
    "targetFirmwareSchedule": 1764726121, // unix timestamp
    "lastUpgradeTime": 1764726121, // unix timestamp
    "upgradeMethod": "manual", // manual, schedule
    "firmwareList": [
      {
        "id": 1,
        "version": "2.0",
        "hasReleaseNote": false,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 2,
        "version": "1.1.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 3,
        "version": "1.0.1",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 4,
        "version": "1.0.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
    ]
  },
  {
    "siteId": "2e7787ef-7f28-493e-8560-e9b69f771999",
    "siteName": "office",
    "siteTimezone": "+08:00",
    "siteTimezoneName": "Asia/Taipei",
    "deviceType": "ap", // ap, switch
    "seriesName": "DAP-X3060",
    "hwVersion": "A",  // Ax, Bx
    "devices": [
      {
        "id": "BC:22:28:72:0F:70",
        "name": "office ap 1",
        "modelName": "DAP-X3060",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
      {
        "id": "BC:22:28:72:0F:80",
        "name": "office ap 2",
        "modelName": "DAP-X3060",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
      {
        "id": "BC:22:28:72:0F:90",
        "name": "office ap 3",
        "modelName": "DAP-X3060",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
    ],
    "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
    "firmwareVersion": "1.0.0",
    "firmwareId": 1,
    "targetFirmwareVersion": "1.0.1",
    "targetFirmwareId": 2,
    "targetFirmwareSchedule": 1764726121, // unix timestamp
    "lastUpgradeTime": 1764726121, // unix timestamp
    "upgradeMethod": "manual", // manual, schedule
    "firmwareList": [
      {
        "id": 1,
        "version": "2.0",
        "hasReleaseNote": false,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 2,
        "version": "1.1.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 3,
        "version": "1.0.1",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 4,
        "version": "1.0.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
    ]
  },
  {
    "siteId": "2e7787ef-7f28-493e-8560-e9b69f771999",
    "siteName": "office",
    "siteTimezone": "+08:00",
    "siteTimezoneName": "Asia/Taipei",
    "deviceType": "ap", // ap, switch
    "seriesName": "DAP-E9560",
    "hwVersion": "A",  // Ax, Bx
    "devices": [
      {
        "id": "BC:22:28:72:0F:70",
        "name": "office ap 1",
        "modelName": "DAP-E9560",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
      {
        "id": "BC:22:28:72:0F:80",
        "name": "office ap 2",
        "modelName": "DAP-E9560",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
      {
        "id": "BC:22:28:72:0F:90",
        "name": "office ap 3",
        "modelName": "DAP-E9560",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      },
    ],
    "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
    "firmwareVersion": "1.0.0",
    "firmwareId": 1,
    "targetFirmwareVersion": "1.0.1",
    "targetFirmwareId": 2,
    "targetFirmwareSchedule": 1764726121, // unix timestamp
    "lastUpgradeTime": 1764726121, // unix timestamp
    "upgradeMethod": "manual", // manual, schedule
    "firmwareList": [
      {
        "id": 1,
        "version": "2.0",
        "hasReleaseNote": false,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 2,
        "version": "1.1.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 3,
        "version": "1.0.1",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 4,
        "version": "1.0.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
    ]
  },
]
const fwList2 = [
  {
    "siteId": "2e7787ef-7f28-493e-8560-e9b69f771999",
    "siteName": "office",
    "siteTimezone": "+08:00",
    "siteTimezoneName": "Asia/Taipei",
    "deviceType": "switch", // ap, switch
    "seriesName": "DXS-3130-54PS",
    "hwVersion": "B",  // Ax, Bx
    "devices": [
      {
        "id": "BC:22:28:72:0F:70",
        "name": "office ap",
        "modelName": "DXS-3130-54PS",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      }
    ],
    "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
    "firmwareVersion": "1.0.0",
    "firmwareId": 1,
    "targetFirmwareVersion": "1.0.1",
    "targetFirmwareId": 2,
    "targetFirmwareSchedule": 1764746121, // unix timestamp
    "lastUpgradeTime": 1764746121, // unix timestamp
    "upgradeMethod": "manual", // manual, schedule
    "firmwareList": [
      {
        "id": 1,
        "version": "2.0",
        "hasReleaseNote": false,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 2,
        "version": "1.0.1",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 3,
        "version": "1.0.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
    ]
  },
  {
    "siteId": "2e7787ef-7f28-493e-8560-e9b69f771999",
    "siteName": "office",
    "siteTimezone": "+08:00",
    "siteTimezoneName": "Asia/Taipei",
    "deviceType": "switch", // ap, switch
    "seriesName": "DMS-1250-10SP",
    "hwVersion": "B",  // Ax, Bx
    "devices": [
      {
        "id": "BC:22:28:72:0F:70",
        "name": "office ap",
        "modelName": "DMS-1250-10SP",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      }
    ],
    "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
    "firmwareVersion": "1.0.0",
    "firmwareId": 1,
    "targetFirmwareVersion": "1.0.1",
    "targetFirmwareId": 2,
    "targetFirmwareSchedule": 1764746121, // unix timestamp
    "lastUpgradeTime": 1764746121, // unix timestamp
    "upgradeMethod": "manual", // manual, schedule
    "firmwareList": [
      {
        "id": 1,
        "version": "2.0",
        "hasReleaseNote": false,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 2,
        "version": "1.0.1",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 3,
        "version": "1.0.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
    ]
  },
  {
    "siteId": "2e7787ef-7f28-493e-8560-e9b69f771999",
    "siteName": "office",
    "siteTimezone": "+08:00",
    "siteTimezoneName": "Asia/Taipei",
    "deviceType": "switch", // ap, switch
    "seriesName": "DMS-1250-12TP",
    "hwVersion": "B",  // Ax, Bx
    "devices": [
      {
        "id": "BC:22:28:72:0F:70",
        "name": "office ap",
        "modelName": "DMS-1250-12TP",
        "hwVersion": "A1",
        "firmwareVersion": "1.0.0",
        "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
      }
    ],
    "firmwareAvailability": "up-to-date", // up-to-date, update-scheduled, update-available
    "firmwareVersion": "1.0.0",
    "firmwareId": 1,
    "targetFirmwareVersion": "1.0.1",
    "targetFirmwareId": 2,
    "targetFirmwareSchedule": 1764746121, // unix timestamp
    "lastUpgradeTime": 1764746121, // unix timestamp
    "upgradeMethod": "manual", // manual, schedule
    "firmwareList": [
      {
        "id": 1,
        "version": "2.0",
        "hasReleaseNote": false,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 2,
        "version": "1.0.1",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
      {
        "id": 3,
        "version": "1.0.0",
        "hasReleaseNote": true,
        "type": "NORMAL",
        "default": true
      },
    ]
  },
]

const mainFWList = {
  data: [].concat(fwList1, fwList2),
  total: fwList1.length + fwList2.length
};

const releaseNote = {
  data: {
    "firmwareId": 1,
    "version": "1.0.1",
    "content":
      `<html>\n
      <head>\n<title></title>\n</head>\n
      <body>\n
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam non velit vitae ipsum tempus volutpat. Ut sed risus non lectus aliquet accumsan ac nec neque. Suspendisse potenti. Fusce vel enim ac mauris vestibulum facilisis. Aliquam erat volutpat. Praesent id tortor ac mauris interdum malesuada nec sit amet lacus.Quisque efficitur metus a ligula euismod, nec malesuada erat fermentum. Proin eget libero in nisi lacinia efficitur.<br><br>
        Mauris eu mauris in massa euismod posuere. Donec consectetur nunc vitae leo feugiat, non luctus odio lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Aliquam interdum, eros a tincidunt malesuada, libero nisi finibus nulla, nec tincidunt magna tellus ut elit.
      </p>\n
      </body>\n
      </html>\n`
  }
}

const supportList = {
  data: [
    {
      "id": 1,
      "version": "2.0",
      "serialName": "DAP-X2810",
      "deviceType": "ap",
      "hwVersion": "A",
      "hasReleaseNote": true,
      "type": "NORMAL",
      "default": true,
      "releaseDate": 1764746121 // unix timestamp
    },
    {
      "id": 2,
      "version": "1.1.0",
      "serialName": "DAP-X2810",
      "deviceType": "ap",
      "hwVersion": "A",
      "hasReleaseNote": true,
      "type": "NORMAL",
      "default": true,
      "releaseDate": 1764745121 // unix timestamp
    },
    {
      "id": 3,
      "version": "1.0.1",
      "serialName": "DAP-X2810",
      "deviceType": "ap",
      "hwVersion": "A",
      "hasReleaseNote": false,
      "type": "NORMAL",
      "default": true,
      "releaseDate": 1764744121 // unix timestamp
    },
    {
      "id": 4,
      "version": "1.0",
      "serialName": "DAP-X2810",
      "deviceType": "ap",
      "hwVersion": "A",
      "hasReleaseNote": true,
      "type": "NORMAL",
      "default": true,
      "releaseDate": 1764745121 // unix timestamp
    },
    {
      "id": 5,
      "version": "2.0",
      "serialName": "DXS-3130-54PS",
      "deviceType": "switch",
      "hwVersion": "B",
      "hasReleaseNote": true,
      "type": "NORMAL",
      "default": true,
      "releaseDate": 1764746100 // unix timestamp
    },
    {
      "id": 6,
      "version": "1.1.0",
      "serialName": "DXS-3130-54PS",
      "deviceType": "switch",
      "hwVersion": "B",
      "hasReleaseNote": false,
      "type": "NORMAL",
      "default": true,
      "releaseDate": 1764745100 // unix timestamp
    },
    {
      "id": 7,
      "version": "2.0",
      "serialName": "DXS-1210",
      "deviceType": "switch",
      "hwVersion": "A",
      "hasReleaseNote": true,
      "type": "NORMAL",
      "default": true,
      "releaseDate": 1764745100 // unix timestamp
    },
  ]
}


export const firmwareManagementsSlice = createSlice({
  name: "firmwareManagements",
  initialState: {
    mainFWList,
    releaseNote,
    supportList
  },
  reducers: {},
});

export default firmwareManagementsSlice.reducer;
